import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import store from "./store"
import { isMobile } from "react-device-detect"
import DeviceOrientation, { Orientation } from "react-screen-orientation"
import { Container } from "reactstrap"
import localJsonData from "./assets/localdata.json"
import { SocketProvider } from "./context/SocketContext";

const loader = document.querySelector(".loader")

const showLoader = () => loader.classList.remove("loader--hide")
const hideLoader = () => loader.classList.add("loader--hide")

const allDeviceSupport = false

const renderApp = () => {
  const app = (
     <SocketProvider>
       <Provider store={store}>
      <BrowserRouter>
        {allDeviceSupport ? (
          <App hideLoader={hideLoader} showLoader={showLoader} />
        ) : isMobile ? (
          <DeviceOrientation lockOrientation={"portrait"}>
            {/* Will only be in DOM in portrait */}
            <Orientation orientation="portrait" alwaysRender={false}>
              <App hideLoader={hideLoader} showLoader={showLoader} />
            </Orientation>
            <Orientation orientation="landscape" alwaysRender={false}>
              <Container style={{ padding: 0, position: "relative" }} fluid>
                <img
                  width="100%"
                  height="100%"
                  alt=" "
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/NS%20PWA%2FRotate%20Your%20Phone.gif?alt=media&token=a377d64a-36ed-498e-92f2-2419f0b1942f"
                  }
                  style={{
                    zIndex: 9999999999999999999,
                    position: "fixed",
                    display: "block",
                    backgroundColor: "white",
                  }}
                  onLoad={() => {
                    loader.classList.add("loader--hide")
                  }}
                />
              </Container>
            </Orientation>
          </DeviceOrientation>
        ) : window.location.pathname === "/activityfeed" ? (
          <App hideLoader={hideLoader} showLoader={showLoader} />
        ) : (
          <DeviceOrientation lockOrientation={"landscape"}>
            {/* Will only be in DOM in portrait */}
            <Orientation orientation="landscape" alwaysRender={false}>
              <Container style={{ padding: 0, position: "relative" }} fluid>
                <img
                  width="100%"
                  height="100%"
                  alt=" "
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/wallmart25%2FLandscape-21.png?alt=media"
                  }
                  style={{
                    zIndex: 9999999999999999999,
                    position: "fixed",
                    display: "block",
                    backgroundColor: "white",
                  }}
                  onLoad={() => {
                    loader.classList.add("loader--hide")
                  }}
                />
              </Container>
            </Orientation>
            <Orientation orientation="portrait" alwaysRender={false}>
              <Container style={{ padding: 0, position: "relative" }} fluid>
                <img
                  width="100%"
                  height="100%"
                  alt="clickable"
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/wallmart25%2FLandscape-21.png?alt=media"
                  }
                  style={{
                    zIndex: 9999999999999999999,
                    position: "fixed",
                    display: "block",
                    backgroundColor: "white",
                  }}
                  onLoad={() => {
                    loader.classList.add("loader--hide")
                  }}
                />
              </Container>
            </Orientation>
          </DeviceOrientation>
        )}
      </BrowserRouter>
    </Provider>
     </SocketProvider>
   
  )

  //

  ReactDOM.render(app, document.getElementById("root"))
}


const fetchAndStoreData = async () => {
  const adminPanel = isMobile
    ? `${process.env.REACT_APP_ADMIN}`
    : `${process.env.REACT_APP_ADMIN_LAPTOP}`

  try {
    // 1. Fetch global data
    const dataResponse = await fetch(`${adminPanel}/getJD`);
    const data = await dataResponse.json();
    localStorage.setItem("dataJ", JSON.stringify(data));

    // 2. If user is logged in, fetch their updated data
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser && authUser._id) {
      const userResponse = await fetch(`${adminPanel}/getUser/${authUser._id}`);
      const userData = await userResponse.json();
      localStorage.setItem("authUser", JSON.stringify(userData));
    }

  } catch (error) {
    console.error("Failed to fetch data:", error);
  }

  hideLoader();
  renderApp();
};



showLoader()
fetchAndStoreData()


// serviceWorker.unregister()
serviceWorker.register()